exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*\n**  Style overrite for the default Intercom display\n*/\n\n#intercom-container {\n  bottom: auto !important;\n  top: 0;\n}\n\n#intercom-container .intercom-messenger-frame {\n  bottom: auto !important;\n  right: auto !important;\n  top: calc(50% - 352px);\n  left: calc(50% - 188px);\n}\n", ""]);

// exports
